/// <amd-module name="SuiteCommerce.GiftCertificate.OptionTiles"/>
define("SuiteCommerce.GiftCertificate.OptionTiles", ["require", "exports", "underscore", "SuiteCommerce.GiftCertificate.Utils.Configuration"], function (require, exports, _, Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.OptionTiles = void 0;
    var OptionTiles = /** @class */ (function () {
        function OptionTiles() {
        }
        OptionTiles.excludeGiftCertificatesFromSearch = function () {
            var searchApiMasterOptions = Configuration_1.Configuration.getSearchApiMasterOptions();
            searchApiMasterOptions.CmsAdapterSearch.custitem_ns_sc_ext_only_pdp = false;
            searchApiMasterOptions.Facets.custitem_ns_sc_ext_only_pdp = false;
            searchApiMasterOptions.itemsSearcher.custitem_ns_sc_ext_only_pdp = false;
            searchApiMasterOptions.merchandisingZone.custitem_ns_sc_ext_only_pdp = false;
            searchApiMasterOptions.relatedItems.custitem_ns_sc_ext_only_pdp = false;
            searchApiMasterOptions.typeAhead.custitem_ns_sc_ext_only_pdp = false;
        };
        OptionTiles.injectInVisualComponent = function (visualComponent, options) {
            _.each(options.viewsToInject, function (viewName) {
                visualComponent.addChildViews(viewName, options.childViewConstructor);
            });
        };
        return OptionTiles;
    }());
    exports.OptionTiles = OptionTiles;
});
